
import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
    MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_BEGIN,
    MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_SUCCESS,
    MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_FAILURE,
    MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function fetchOrderDetailData(args = {}) {
    return (dispatch, getState) => { // optionally you can have getState as the second argument
        dispatch({
            type: MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_BEGIN,
        });
        const promise = new Promise((resolve, reject) => {
            const cognitoIdToken = getState().home.auth.cognitoIdToken;
            const token = `Bearer ${cognitoIdToken}`;
            const doRequest = axios.post(`${API_REQUEST_URL}/getOrderDetail`, args, {
                headers: {
                    'Authorization': token,
                }
            });
            doRequest.then(
                (res) => {
                    const data = res.data;
                    dispatch({
                        type: MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_SUCCESS,
                        data: data,
                    });
                    resolve(data);
                },
                // Use rejectHandler as the second argument so that render errors won't be caught.
                (err) => {
                    const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
                    dispatch({
                        type: MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_FAILURE,
                        data: { error: errorMsg },
                    });
                    reject(err);
                },
            );
        });

        return promise;
    };
}

export function dismissFetchOrderDetailDataError() {
    return {
        type: MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_DISMISS_ERROR,
    };
}

export function useFetchOrderDetailData() {
    const dispatch = useDispatch();

    const { orderDetail, fetchOrderDetailDataPending, fetchOrderDetailDataError } = useSelector(
        state => ({
            orderDetail: state.manageSubs.orderDetail,
            fetchOrderDetailDataPending: state.manageSubs.fetchOrderDetailDataPending,
            fetchOrderDetailDataError: state.manageSubs.fetchOrderDetailDataError,
        }),
        shallowEqual,
    );

    const boundAction = useCallback((...args) => {
        return dispatch(fetchOrderDetailData(...args));
    }, [dispatch]);

    const boundDismissError = useCallback(() => {
        return dispatch(dismissFetchOrderDetailDataError());
    }, [dispatch]);

    return {
        orderDetail,
        fetchOrderDetailData: boundAction,
        fetchOrderDetailDataPending,
        fetchOrderDetailDataError,
        dismissFetchOrderDetailDataError: boundDismissError,
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_BEGIN:
            // Just after a request is sent
            return {
                ...state,
                fetchOrderDetailDataPending: true,
                fetchOrderDetailDataError: null,
            };

        case MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_SUCCESS:
            // The request is success
            return {
                ...state,
                orderDetail: action.data,
                fetchOrderDetailDataPending: false,
                fetchOrderDetailDataError: null,
            };

        case MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_FAILURE:
            // The request is failed
            return {
                ...state,
                fetchOrderDetailDataPending: false,
                fetchOrderDetailDataError: action.data.error,
            };

        case MANAGE_SUBS_FETCH_ORDER_DETAIL_DATA_DISMISS_ERROR:
            // Dismiss the request failure error
            return {
                ...state,
                fetchOrderDetailDataError: null,
            };

        default:
            return state;
    }
}
